import { buildVideoRoute, FALLBACK_LINK } from '~/routes';
import { BREAKPOINTS_VALUES } from '~/theme';
import { Maybe, Video } from '~/types';
import { VideoProgressData } from '~/utils/videoProgressUtils';

export const getBreakpointsForSlider = (isPortraitOrientation: boolean) => ({
  [BREAKPOINTS_VALUES.ml]: {
    slidesPerView: isPortraitOrientation ? 6 : 5.2,
  },
  [BREAKPOINTS_VALUES.xl]: {
    slidesPerView: isPortraitOrientation ? 5 : 4.2,
  },
  [BREAKPOINTS_VALUES.lg]: {
    slidesPerView: isPortraitOrientation ? 4 : 3.5,
  },
  [BREAKPOINTS_VALUES.md]: {
    slidesPerView: isPortraitOrientation ? 3 : 2.5,
  },
  [BREAKPOINTS_VALUES.sm]: {
    slidesPerView: isPortraitOrientation ? 3 : 1.6,
    slidesOffsetAfter: isPortraitOrientation ? 0 : 16,
  },
  [BREAKPOINTS_VALUES.xs]: {
    slidesPerView: isPortraitOrientation ? 2.5 : 1.2,
    slidesOffsetAfter: isPortraitOrientation ? 0 : 16,
  },
});

export interface VideoWithProgress extends Video {
  link: string;
  userName?: string;
  userSlug?: Maybe<string>;
  progress: number;
  lastPositionPercent: number;
  completed: boolean;
  new: boolean;
  isInWatchlist: boolean;
}

export const bindProgressToVideo =
  (
    progressDataByVideoId?: Record<string, VideoProgressData>,
    watchlistById: Record<string, boolean> = {},
  ) =>
  (video: Video): VideoWithProgress => {
    const id = video?.id;
    const videoUrl = video?.video_url || id;
    const progressDataByVideo = id ? progressDataByVideoId?.[id] : null;
    const link = progressDataByVideo ? progressDataByVideo.link : buildVideoRoute(videoUrl);

    return {
      ...video,
      link: link || FALLBACK_LINK,
      userName: video?.user?.name,
      userSlug: video?.user?.slug,
      progress: progressDataByVideo?.progress || 0,
      lastPositionPercent: progressDataByVideo?.lastPositionPercent || 0,
      completed: Boolean(progressDataByVideo?.completed),
      new: Boolean(progressDataByVideo?.new),
      isInWatchlist: Boolean(id && watchlistById[id]),
    };
  };

export const calculateProgress = (watchedVideos?: number | null, totalVideos?: number | null) => {
  if (typeof watchedVideos === 'number' && totalVideos) {
    const progress = Math.round((watchedVideos * 100) / totalVideos);
    return progress <= 100 ? progress : 100;
  } else {
    return 0;
  }
};

export const formatGoalsCategories = (categories: string[], separator: string) => {
  return categories.length > 1
    ? `${categories.slice(0, -1).join(', ')} ${separator} ${categories.slice(-1)}`
    : categories[0];
};
